import React from 'react'
import ProjectsList from "../assets/content/ProjectsList"

export default function Projects() {
  return (
    <div className="py-24">
      <div className="text-center mb-12">
        <p className="section-label">{"// projects"}</p>
        <h2 className="text-[1.5rem] sm:text-[1.75rem] font-bold text-title mb-2">What I've Built</h2>
        <p className="text-sm text-muted">A selection of security and cloud projects.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {ProjectsList.map((project) => (
          <article key={project.uid} className="card flex flex-col gap-4 p-6 hover:shadow-md transition-shadow">
            <div className="flex items-center justify-between gap-3">
              <div className="flex items-center gap-3">
                <i className={`${project.icon} text-xl text-accent`}></i>
                <h3 className="font-bold text-title text-[1rem]">{project.title}</h3>
              </div>
              <a
                href={project.url}
                target="_blank"
                rel="noreferrer"
                aria-label={`Open ${project.title}`}
                className="shrink-0 text-subtle hover:text-title transition-colors"
              >
                <i className="ri-arrow-right-up-line text-lg"></i>
              </a>
            </div>

            <p className="text-sm text-muted leading-relaxed flex-1">{project.description}</p>

            <div className="flex flex-wrap gap-2">
              {project.tags.map(tag => (
                <span key={tag} className="tag">{tag}</span>
              ))}
            </div>
          </article>
        ))}
      </div>

      <div className="text-center mt-10">
        <a
          href="https://github.com/hhphu"
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-1.5 text-sm text-muted hover:text-title transition-colors"
        >
          View all on GitHub <i className="ri-arrow-right-up-line"></i>
        </a>
      </div>
    </div>
  )
}
